import { toast } from "react-toastify";
import httpService from "./http.service";

export const getKey = async () => {
  try {
    const data = await httpService.get("/v2/keys");
    return data;
  } catch (err) {
    toast.error(err.message);
  }
};

export const createKey = async (payload) => {
  try {
    const data = await httpService.post("/v2/keys", payload);
    return data;
  } catch (err) {
    toast.error(err.message);
  }
};
